import React from 'react';
import '../../Styles/Sass/Contact.scss';
import { firestore } from '../../firebase.js';
import { useContext } from "react";
import { UserContext } from "../../Providers/UserProvider";

function Contact() {
		/*	On submit nameForm, emailForm and messageForm to the contactForm collection
			Issues: 
		*/
		const user = useContext(UserContext);
		const submitHandler = (e) => {
			e.preventDefault();
			firestore.collection('contactFom').doc(user.uid)
			  .update({
				nameForm: e.target.name.value,
				emailForm: e.target.email.value,
				messageForm: e.target.message.value,
			  })
			  .then(res => {
				console.log(res);
			  })
			  .catch(err => {
				console.log(err);
			  })
		  }
		return (
			<section className='contact'>
				<h2 className='contact__title'>Contact Us</h2>
				<form onSubmit={submitHandler} className='contactForm'>
					<label className='contactForm__label' htmlFor="name" required>Enter Your Name *</label>
					<input className='contactForm__input' name='name' type="text" required/>
					<label className='contactForm__label' htmlFor="email" required>Enter Your Email *</label>
					<input className='contactForm__input' name='email' type="email" required/>
					<label className='contactForm__label' htmlFor="message">Enter Your Message *</label>
					<textarea className='contactForm__input contactForm__input--area' name="message"></textarea>
					<button type='submit' className='greenButton contactForm__button'>Submit</button>
				</form>
			</section>
		)
	
}

export default Contact;